export const responseSnowflakeAccountMapping = '';